import React, { useEffect, useState } from 'react';
import { useSetting } from '../../../util/useSetting';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import LoadingPage from '../../components/LoadingPage';
import { fetchSchoolMissions, teacherUpdateSchoolMission } from '../../../services2/schoolMissions.service';

const temp = [
    {
        id: '4',
        name: '唐詩氣象',
        subtitle: '〈月下獨酌（其一）〉｜',
        subtitle2: '〈山居秋暝〉｜',
        subtitle3: '〈登樓〉',
        image: '/secondary/tasks/pp2.png'
    },
    {
        id: '5',
        name: '風雅宋聲',
        subtitle: '〈念奴嬌・赤壁懷古〉｜',
        subtitle2: '〈聲聲慢・秋情〉｜',
        subtitle3: '〈青玉案・元夕〉',
        image: '/secondary/tasks/pp3.png'
    },
    {
        id: '1',
        name: '托物言志',
        subtitle: '〈愛蓮說〉｜',
        subtitle2: '〈醜石〉',
        image: '/secondary/temp/1.png'
    },
    {
        id: '2',
        name: '借事說理',
        subtitle: '〈傷仲永〉｜',
        subtitle2: '〈習慣說〉',
        image: '/secondary/temp/2.png'
    },
    {
        id: '3',
        name: '平淡之宗',
        subtitle: '〈桃花源記〉｜',
        subtitle2: '〈歸園田居〉',
        image: '/secondary/tasks/pp1.png'
    }
]

function StudentTaskListPopup(props) {
    const { fontSize } = useSetting();
    const student = props.student
    const [data, setdata] = useState(null)
    const [isLoading, setisLoading] = useState(true)
    const [total, settotal] = useState(0)

    const navigate = useNavigate();

    const handleDownloadData = () => {
        alert('開發中')
    }

    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        const filter = {}
        // if (status !== '全部') filter.status = status
        let result = await fetchSchoolMissions(props.token.token, filter, { limit: 99, skip: 0 });
        if (result.result) {
            setdata(result.result)
            settotal((result.count || 0) + temp.length)
        } else {
            alert('Fetch data error')
        }
        setisLoading(false)
    }



    useEffect(() => {
        fetchData(true)
    }, [])


    return (
        <div className='absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center noto-san-hk' style={{ fontSize }}>
            <div className='w-[1800px] max-w-[95%] rounded-[24px] flex flex-col bg-[#F0FBFF] p-[16px] gap-[16px] max-h-[90%]' style={{ backgroundImage: 'url(/secondary/tasks/bg4.png)', backgroundSize: 'cover', backgroundPosition: 'right', backgroundRepeat: 'no-repeat', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                <div className='flex flex-row gap-[8px] items-end w-full flex-wrap'>
                    <div className='flex flex-col gap-[16px] flex-1'>
                        <div className='font-bold'>學生姓名</div>
                        <div className='bg-[#E1E1E1] px-[14px] py-[4px] rounded-[4px]'>{student?.name}</div>
                    </div>
                    <div className='flex flex-col gap-[16px] flex-1'>
                        <div className='font-bold'>班級</div>
                        <div className='bg-[#E1E1E1] px-[14px] py-[4px] rounded-[4px]'>{student?.class || ''}</div>
                    </div>
                    <div className='flex flex-col gap-[16px] flex-[2]'>
                        <div className='font-bold'>電郵</div>
                        <div className='bg-[#E1E1E1] px-[14px] py-[4px] rounded-[4px]'>{student?.username || ''}</div>
                    </div>
                    <button onClick={(handleDownloadData)} className='text-[white] text-[16px] font-[700] px-[24px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#63BBD1]' style={{ background: 'linear-gradient(90deg, #178E95 0%, #07162F 100%)' }}>
                        下載學生數據
                    </button>
                </div>
                <b>學生進度</b>
                <div className='flex flex-row w-full flex-wrap justify-start items-start  overflow-auto gap-[8px]'>
                    {data?.map((item, index) =>
                        <div key={item?._id} className='relative flex-1 flex flex-row gap-[8px] rounded-[16px] max-w-[500px] min-w-[33%] font-bold overflow-hidden bg-white' style={{ border: '1px solid #E0E0E0' }}>
                            <div className='flex-1 flex flex-col'>
                                <img src={item?.mission.photo} alt={item?.mission?.name} className='w-full object-cover rounded-[16px]' style={{ aspectRatio: '228/119' }} />
                                <div className='p-[16px]' style={{ fontWeight: 900, fontSize: fontSize + 4 }}>{item?.mission?.name}</div>
                            </div>
                            <div className='flex-1 flex-col p-[8px] flex justify-start gap-[8px]' style={{ fontSize: fontSize - 2 }}>
                                <div className='flex flex-row items-center justify-start gap-[16px] z-[2] w-full' style={{}}>
                                    <div className='flex-1'>{item.mission?.categories[0]}</div>
                                    <button className='flex-1 text-[#A9FFDC] bg-[#009191] rounded-full px-[24px] py-[8px]' onClick={() => {
                                        navigate(`/platform2/studentmissions/${item?._id}/${student?._id}?session=互文閱讀一`)
                                    }}>查看成績</button>
                                </div>
                                <div className='flex flex-row items-center justify-start gap-[16px] z-[2] w-full' style={{}}>
                                    <div className='flex-1'>{item.mission?.categories[1]}</div>
                                    <button className='flex-1 text-[#A9FFDC] bg-[#009191] rounded-full px-[24px] py-[8px]' onClick={() => {
                                       navigate(`/platform2/studentmissions/${item?._id}/${student?._id}?session=互文閱讀二`)
                                    }}>查看成績</button>
                                </div>
                                <div className='flex flex-row items-center justify-start gap-[16px] z-[2] w-full' style={{}}>
                                    <div className='flex-1'>單元習題</div>
                                    <button className='flex-1 text-[#aaa] rounded-full px-[24px] py-[8px]' style={{ background: 'linear-gradient(to bottom, #BEBEBE80, #F0FBFF)' }} onClick={() => {
                                       navigate(`/platform2/studentmissions/${item?._id}/${student?._id}?session=單元習題`)
                                    }}>未完成</button>
                                </div>

                            </div>
                        </div>
                    )}
                    {data && temp?.map((item, index) =>
                        <div key={item?._id} className='relative flex-1 flex flex-row gap-[8px] rounded-[16px] max-w-[500px] min-w-[33%] font-bold overflow-hidden bg-white' style={{ border: '1px solid #E0E0E0' }}>
                            <div className='flex-1 flex flex-col'>
                                <img src={item?.image} alt={item?.name} className='w-full object-cover rounded-[16px]' style={{ aspectRatio: '228/119' }} />
                                <div className='p-[16px]' style={{ fontWeight: 900, fontSize: fontSize + 4 }}>{item?.name}</div>
                            </div>
                            <div className='flex-1 flex-col p-[8px] flex justify-start gap-[8px]' style={{ fontSize: fontSize - 2 }}>
                                <div className='flex flex-row items-center justify-start gap-[16px] z-[2] w-full' style={{}}>
                                    <div className='flex-1'>文化傳統</div>
                                    <button className='flex-1 text-[#aaa] rounded-full px-[24px] py-[8px]' style={{ background: 'linear-gradient(to bottom, #BEBEBE80, #F0FBFF)' }}>未完成</button>
                                </div>
                                <div className='flex flex-row items-center justify-start gap-[16px] z-[2] w-full' style={{}}>
                                    <div className='flex-1'>作者處境</div>
                                    <button className='flex-1 text-[#aaa] rounded-full px-[24px] py-[8px]' style={{ background: 'linear-gradient(to bottom, #BEBEBE80, #F0FBFF)' }}>未完成</button>
                                </div>
                                <div className='flex flex-row items-center justify-start gap-[16px] z-[2] w-full' style={{}}>
                                    <div className='flex-1'>單元習題</div>
                                    <button className='flex-1 text-[#aaa] rounded-full px-[24px] py-[8px]' style={{ background: 'linear-gradient(to bottom, #BEBEBE80, #F0FBFF)' }}>未完成</button>
                                </div>

                            </div>
                        </div>
                    )}
                </div>
                <div className='flex flex-row gap-[16px] w-full justify-center'>
                    <button onClick={props.onClose} className='text-black text-[16px] font-[700] px-[48px] py-[12px] rounded-full cursor-pointer hover:opacity-[.5] bg-[#63BBD1]' style={{ background: 'linear-gradient(to bottom, #BEBEBE90 0%, #F0FBFF 100%)' }}>
                        取消
                    </button>
                </div>
            </div>
            {isLoading && <LoadingPage />}
        </div>
    )
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(StudentTaskListPopup)
